import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import ModalMixin from '@/amui/mixins/modalMixin';
let AmFeDialog = class AmFeDialog extends Mixins(ModalMixin) {};
AmFeDialog.componentName = 'AmFeDialog';
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_dialog_title', '对话框');
  }
})], AmFeDialog.prototype, "title", void 0);
__decorate([Prop({
  default: 'default'
})], AmFeDialog.prototype, "paddingSize", void 0);
AmFeDialog = __decorate([Component({
  name: 'AmFeDialog'
})], AmFeDialog);
export default AmFeDialog;